<template>
  <div id="requisition">
    <div class="header flex-between">
      <div class="header-text">
        <h1>GIADA Friends申请</h1>
      </div>

      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="el-icon-search"
          @click="searchBtn"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="el-icon-circle-plus-outline"
          @click="(createVisible = true), (createFormAlign = {})"
          >创建</el-button
        >
        <el-button
          v-if="jurisdiction.edit"
          icon="el-icon-edit-outline"
          @click="openEditShow()"
          >修改</el-button
        >
        <el-button
          v-if="jurisdiction.delete"
          icon="el-icon-delete"
          @click="deleteUser()"
          >删除</el-button
        >
        <el-button
          v-if="jurisdiction.examine"
          icon="iconfont icon-chakan1"
          @click="auditBtn()"
          >审核</el-button
        >
      </div>
    </div>

    <el-card shadow="never" :body-style="bodyStyle">
      <div style="padding: 15px 0 0 15px">
        <el-form
          label-width="115px"
          :model="searchFormLabelAlign"
          size="small"
          :inline="true"
        >
          <el-form-item label="申请人姓名\手机号">
            <el-input v-model="searchFormLabelAlign.search"></el-input>
          </el-form-item>
          <el-form-item label="公司">
            <el-input v-model="searchFormLabelAlign.company"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select style="width: 100%" v-model="searchFormLabelAlign.state">
              <el-option :value="null" label="全部"></el-option>
              <el-option
                v-for="item in stateOptions"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建日期从">
            <el-date-picker
              v-model="dateValue"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <!-- 创建弹窗 -->
    <div class="create">
      <el-dialog
        :close-on-click-modal="false"
        width="650px"
        title="GIADA Friends申请-创建"
        :visible.sync="createVisible"
      >
        <el-form
          size="mini"
          :label-position="labelPosition2"
          label-width="80px"
          :model="createFormAlign"
          ref="createRef"
          :rules="rules"
        >
          <el-row :gutter="50" style="margin-top: 30px">
            <el-col :span="12">
              <el-form-item label="申请人姓" prop="GFLastName">
                <el-input v-model="createFormAlign.GFLastName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申请人名" prop="GFFirstName">
                <el-input v-model="createFormAlign.GFFirstName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="性别">
                <el-select style="width: 100%" v-model="createFormAlign.gender">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                style="margin-bottom: 20px"
                label="移动电话"
                prop="mobile"
              >
                <el-input
                  v-model="createFormAlign.mobile"
                  maxlength="11"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="公司名称">
                <el-input v-model="createFormAlign.company"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="职位">
                <el-input v-model="createFormAlign.position"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="邮箱">
                <el-input v-model="createFormAlign.GFEmail"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="省份">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="createFormAlign.stateID"
                  @change="provinceChange"
                >
                  <el-option
                    v-for="item in provinceData"
                    :key="item.stateID"
                    :value="item.stateID"
                    :label="item.stateName_cn"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="城市">
                <el-select
                  style="width: 100%"
                  v-model="createFormAlign.cityID"
                  @focus="focus"
                >
                  <el-option
                    v-for="item in cityData"
                    :key="item.cityID"
                    :value="item.cityID"
                    :label="item.cityName_en"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="详细地址">
                <el-input v-model="createFormAlign.address"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="createTable">确 定</el-button>
          <el-button @click="createVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改弹窗 -->
    <div class="revise">
      <el-dialog
        :close-on-click-modal="false"
        width="650px"
        title="GIADA Friends申请-修改"
        :visible.sync="reviseVisible"
      >
        <el-form
          size="mini"
          :label-position="labelPosition2"
          label-width="80px"
          :model="formLabelAlign"
          ref="createRef"
          :rules="rules"
        >
          <el-row :gutter="50" style="margin-top: 30px">
            <el-col :span="12">
              <el-form-item label="申请人姓" prop="GFLastName">
                <el-input v-model="formLabelAlign.GFLastName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申请人名" prop="GFFirstName">
                <el-input v-model="formLabelAlign.GFFirstName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="性别">
                <el-select style="width: 100%" v-model="formLabelAlign.gender">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                style="margin-bottom: 20px"
                label="移动电话"
                prop="mobile"
              >
                <el-input v-model="formLabelAlign.mobile"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="公司名称">
                <el-input v-model="formLabelAlign.company"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="职位">
                <el-input v-model="formLabelAlign.position"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="邮箱">
                <el-input v-model="formLabelAlign.gfemail"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="省份">
                <el-select
                  style="width: 100%"
                  @change="provinceChange"
                  v-model="formLabelAlign.stateID"
                >
                  <el-option
                    v-for="item in provinceData"
                    :key="item.stateID"
                    :value="item.stateID"
                    :label="item.stateName_cn"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="城市">
                <el-select
                  style="width: 100%"
                  v-model="formLabelAlign.cityID"
                  @focus="focus"
                >
                  <el-option
                    v-for="item in cityData"
                    :key="item.cityID"
                    :value="item.cityID"
                    :label="item.cityName_en"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="详细地址">
                <el-input v-model="formLabelAlign.address"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="submitEdit()">确 定</el-button>
          <el-button
            @click="
              (reviseVisible = false),
                (template = {}),
                (radioxz = ''),
                (formLabelAlign = {})
            "
            >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 审核弹窗 -->
    <div class="audit">
      <el-dialog
        :close-on-click-modal="false"
        width="40%"
        title="GIADA Friends申请-审核"
        :visible.sync="auditVisible"
      >
        <el-form
          size="mini"
          :label-position="labelPosition2"
          label-width="80px"
          :model="auditFormLabelAlign"
          style="margin-top: 10px"
        >
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="申请人姓">
                <el-input
                  v-model="auditFormLabelAlign.gflastName"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申请人名">
                <el-input
                  v-model="auditFormLabelAlign.gffirstName"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="性别">
                <el-select
                  disabled
                  style="width: 100%"
                  v-model="auditFormLabelAlign.gender"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="移动电话">
                <el-input
                  v-model="auditFormLabelAlign.mobile"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="公司名称">
                <el-input
                  v-model="auditFormLabelAlign.company"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="职位">
                <el-input
                  v-model="auditFormLabelAlign.position"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="邮箱">
                <el-input
                  v-model="auditFormLabelAlign.gfemail"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="省份">
                <el-select
                  disabled
                  v-model="auditFormLabelAlign.stateID"
                ></el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="城市">
                <el-select
                  disabled
                  v-model="auditFormLabelAlign.cityID"
                ></el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="详细地址">
                <el-input
                  v-model="auditFormLabelAlign.address"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item style="margin-bottom: 20px" label="状态">
                <el-input
                  disabled
                  :value="
                    auditFormLabelAlign.state == 0
                      ? '审核通过'
                      : auditFormLabelAlign.state == 1
                      ? '未审核'
                      : auditFormLabelAlign.state == 2
                      ? '审核未通过,资质不符合'
                      : '审核未通过，信息不全'
                  "
                ></el-input>
                <!-- <el-select
                    style="width: 100%"
                    v-model="searchFormLabelAlign.state"
                  >
                    <el-option v-for="item in stateOptions" 
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                    >
                    </el-option>
                </el-select>-->
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item style="margin-bottom: 20px" label="审核备注">
                <el-input
                  type="textarea"
                  v-model="auditFormLabelAlign.reviewNotes"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="(auditVisible = false), toExamine(0)"
            >审核通过</el-button
          >
          <el-button @click="toExamine(2)">审核不通过</el-button>
          <el-button @click="auditVisible = false">取 消</el-button>
        </div>
        <!-- --------- -->
      </el-dialog>
    </div>
    <!-- 删除弹窗 -->
    <div class="delete">
      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="删除会员确认取消对话框"
        :visible.sync="deleteFormVisible"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要
            <span style="color: #ff0000">删除</span>会员信息?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="deleteDialog">确 定</el-button>
          <el-button @click="deleteFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>

    <div>
      <el-card shadow="never" style="margin-top: 10px">
        <el-table
          height="530px"
          size="small"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          v-loading="loading"
          v-el-table-infinite-scroll="load"
          infinite-scroll-disabled="onLoading"
        >
          <el-table-column type="index" width="55"></el-table-column>
          <el-table-column label width="30">
            <template slot-scope="scope">
              <el-radio
                :label="scope.$index"
                v-model="radioxz"
                @change.native="getCurrentRow(scope.row)"
                >&nbsp;</el-radio
              >
            </template>
          </el-table-column>
          <el-table-column label="申请人姓名">
            <template slot-scope="scope"
              >{{ scope.row.gflastName }}{{ scope.row.gffirstName }}</template
            >
          </el-table-column>
          <el-table-column prop="gender" label="性别"></el-table-column>
          <el-table-column prop="mobile" label="移动电话"></el-table-column>
          <el-table-column prop="company" label="公司名称"></el-table-column>
          <el-table-column prop="position" label="职位"></el-table-column>
          <el-table-column prop="gfemail" label="邮箱"></el-table-column>
          <el-table-column prop="stateName" label="省份"></el-table-column>
          <el-table-column prop="cityName" label="城市"></el-table-column>
          <el-table-column prop="state" label="状态">
            <template slot-scope="scope">
              {{
                scope.row.state == 0
                  ? "审核通过"
                  : scope.row.state == 1
                  ? "未审核"
                  : scope.row.state == 2
                  ? "审核未通过,资质不符合"
                  : "审核未通过，信息不全"
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="创建人"
            prop="createUserName"
          ></el-table-column>
          <el-table-column prop="createTime" label="创建日期">
            <template slot-scope="scope">{{
              scope.row.createTime | dateFormat
            }}</template>
          </el-table-column>
          <el-table-column
            label="最后修改人"
            prop="updateUserName"
          ></el-table-column>
          <el-table-column prop="updateTime" label="最后修改日期">
            <template slot-scope="scope">
              <span v-if="scope.row.updateTime">{{
                scope.row.updateTime | dateFormat
              }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" align="center" min-width="100">
            <template slot-scope="scope">
              <div class="table-button">
                <el-button
                  size="mini"
                  title="审核"
                  icon="iconfont icon-chakan1"
                  @click="auditBtn(scope.row)"
                ></el-button>
                <el-button
                  size="mini"
                  title="修改"
                  icon="iconfont icon-xiugai1"
                  @click="openEditShow(scope.row)"
                ></el-button>
                <el-button
                  size="mini"
                  title="删除"
                  icon="iconfont icon-a-shanchu11"
                  @click="deleteUser(scope.row)"
                ></el-button>
              </div>
            </template>
          </el-table-column> -->
        </el-table>
        <el-alert
          v-if="total <= tableData.length"
          title="没有更多数据了!"
          type="warning"
          center
          :closable="false"
        ></el-alert>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getcpyNo } from "@/utils/auth";
//获取省市
import {
  friendQuery,
  friendInsert,
  friendUpdate,
  friendDelete,
  applyExamine,
} from "@/api/friends";
import {
  provinceApi,
  cityApi,
} from "@/api/region"; //省份
export default {
  name: "centre",
  data() {
    return {
      dateValue: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      radioxz: "",
      deleteFormVisible: false,
      // 创建弹窗
      createVisible: false,
      // 修改弹窗
      reviseVisible: false,
      // 审核弹窗
      auditVisible: false,
      labelPosition: "right",
      labelPosition2: "left",
      // 创建
      createFormAlign: {
        cpyNO: getcpyNo(),
        GFLastName: "",
        GFFirstName: "",
        gender: "",
        mobile: "",
        company: "",
        position: "",
        GFEmail: "",
        stateID: "", //省份
        cityID: "",
        address: "",
      },
      // 删除的ID
      ID: Number,
      options: [
        { value: "男", label: "男" },
        { value: "女", label: "女" },
      ],
      // 审核列表数据
      auditFormLabelAlign: [],
      //查询
      searchFormLabelAlign: {
        cpyNO: "",
        pageNo: 1,
        pageSize: 50,
        search: "",
        company: "",
        state: "",
        startDay: "",
        endDay: "",
      },
      auditId: Number,
      form: {
        name: "",
      },
      // 状态
      stateOptions: [
        { value: 0, label: "审核通过" },
        { value: 1, label: "未审核" },
        { value: 2, label: "审核未通过，资质不符合" },
        { value: 3, label: "审核未通过，信息不全" },
      ],
      // 修改
      formLabelAlign: {
        GFFirstName: "",
        GFLastName: "",
      },
      queryInfo: {
        cpyNo: getcpyNo(),
        pageNo: 1,
        pageSize: 50,
      },
      tableData: [],
      total: 0,
      size: 0,
      pageSize: 50,
      // 新增表单验证规则
      rules: {
        GFLastName: [
          { required: true, message: "请输入申请人姓", trigger: "blur" },
          { min: 1, trigger: "blur" },
        ],
        GFFirstName: [
          { required: true, message: "请输入申请人名", trigger: "blur" },
          { min: 1, trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请输入申请手机号", trigger: "blur" },
        ],
      },
      provinceData: [], //省份列表
      cityData: [], //城市列表
      provinceValue: "", //选中省份值
      templatei: {},
      bodyStyle: {
        padding: "0px",
      },
      jurisdiction: {
        search: false,
        create: false,
        edit: false,
        examine: false,
        delete: false,
      },
      lock: false,
      loading: false,
    };
  },
  created() {
    this.loading = true;
    this.friendTable();
    this.getProvince();
    let Requisition = JSON.parse(localStorage.getItem("Requisition"));
    console.log(Requisition);
    for (let i = 0; i < Requisition.length; i++) {
      if (Requisition[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (Requisition[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }

      if (Requisition[i].menuName == "修改") {
        this.jurisdiction.edit = true;
        continue;
      }
      if (Requisition[i].menuName == "审核") {
        this.jurisdiction.examine = true;
        continue;
      }
      if (Requisition[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }
    }
  },
  computed: {
    onLoading() {
      console.log(this.total, this.tableData.length);
      return this.loading || this.total < this.tableData.length;
    },
  },
  methods: {
    load() {
      if (this.loading) {
        return;
      }
      setTimeout(() => {
        if (this.total > this.tableData.length) {
          this.queryInfo.pageNo += 1;
          this.friendTable();
        }
      }, 1000);
    },
    //判断是否有先选择城市
    focus() {
      if (this.cityData.length < 1) {
        this.$message.info("请先选择省份");
      }
    },
    //审核
    toExamine(state) {
      console.log(this.auditFormLabelAlign.reviewNotes);
      applyExamine({
        ID: this.auditFormLabelAlign.id,
        state: state,
        reviewNotes: this.auditFormLabelAlign.reviewNotes,
      }).then((res) => {
        if (res.success) {
          this.auditVisible = false;
          this.$message.success(res.message);
          this.tableData = [];
          this.queryInfo.pageNo = 1;
          this.friendTable();
          this.radioxz = "";
          this.templatei = {};
          this.auditVisible = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //确定修改
    submitEdit() {
      let data = {
        GFCrmID: this.formLabelAlign.GFCrmID,
        GFEmail: this.formLabelAlign.GFEmail,
        GFFirstName: this.formLabelAlign.GFFirstName,
        GFLastName: this.formLabelAlign.GFLastName,
        ID: this.formLabelAlign.id,
        address: this.formLabelAlign.address,
        cityID: this.formLabelAlign.cityID,
        company: this.formLabelAlign.company,
        countryID: this.formLabelAlign.countryID,
        gender: this.formLabelAlign.gender,
        mobile: this.formLabelAlign.mobile,
        position: this.formLabelAlign.position,
        reviewNotes: this.formLabelAlign.reviewNotes,
        state: this.formLabelAlign.state,
        stateID: this.formLabelAlign.stateID,
      };
      this.$refs.createRef.validate(async (valid) => {
        if (valid) {
          await friendUpdate(data).then((res) => {
            if (res.message == "success") {
              this.$message.success(res.message);
              this.reviseVisible = false;
              this.tableData = [];
              this.queryInfo.pageNo = 1;
              this.friendTable();
              this.radioxz = "";
              this.templatei = {};
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    //打开修改弹窗
    openEditShow(row) {
      if (row) {
        this.templatei = row;
      }
      if (this.templatei.id) {
        this.formLabelAlign = {
          GFLastName: this.templatei.GFLastName,
          GFFirstName: this.templatei.GFFirstName,
          gender: this.templatei.gender,
          mobile: this.templatei.mobile,
          company: this.templatei.company,
          position: this.templatei.position,
          gfemail: this.templatei.gfemail,
          stateID: this.templatei.stateID,
          cityID: this.templatei.cityID,
          address: this.templatei.address,
          GFCrmID: this.templatei.gfcrmID,
          GFEmail: this.templatei.gfemail,
          id: this.templatei.id,
          countryID: this.templatei.countryID,
          reviewNotes: this.templatei.reviewNotes,
          state: this.templatei.state,
        };
        if (this.formLabelAlign.stateID) {
          this.cityList(this.formLabelAlign.stateID);
        }

        this.reviseVisible = true;
      } else {
        this.$message.error("请先选中一行数据");
      }
    },
    currentChange(row) {
      this.queryInfo.pageNo = row;
      this.queryInfo.pageNo = 1;
      this.friendTable();
    },
    //获取省份列表
    getProvince() {
      provinceApi({
        countryID: "CN",
      }).then((res) => {
        this.provinceData = res.data;
      });
    },
    //省份选中
    provinceChange(value) {
      this.provinceValue = value;
      this.formLabelAlign.cityID = "";
      this.cityData = [];
      this.cityList(value);
    },
    // 城市
    cityList(stateID) {
      cityApi({ stateID: stateID }).then((res) => {
        this.cityData = res.data;
      });
    },

    // 获取选中数据   row表示选中这一行的数据，可以从里面提取所需要的值
    getCurrentRow(row) {
      this.templatei = row;
      console.log(this.templatei);
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    //table列表
    async friendTable() {
      this.loading = true;
      const { data: res } = await friendQuery(this.queryInfo);
      if(this.queryInfo.pageNo==1)this.tableData=[];
      this.tableData = this.tableData.concat(res.list);
      this.loading = false;
      this.total = res.total;
      this.size = res.size;
      this.pageSize = res.pageSize;
    },

    // 查询
    async searchBtn() {
      if (this.lock) {
        return;
      }
      this.loading = true;
      this.lock = true;
      this.queryInfo.pageNo = 1;
      this.tableData = [];
      if (this.dateValue && this.dateValue.length > 0) {
        this.searchFormLabelAlign.startDay = this.renderTime(
          this.dateValue[0]
        ).substring(0, 10);
        this.searchFormLabelAlign.endDay = this.renderTime(
          this.dateValue[1]
        ).substring(0, 10);
      } else {
        this.searchFormLabelAlign.startDay = "";
        this.searchFormLabelAlign.endDay = "";
      }

      await friendQuery(this.searchFormLabelAlign).then((res) => {
        if (res.success == true) {
          this.tableData = res.data.list;
          this.size = res.data.size;
          this.total = res.data.total;
          this.pageNo = res.data.pageNo;
          setTimeout(() => {
            this.lock = false;
            this.loading = false;
          }, 1000);
        }
      });
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    // 创建
    createTable() {
      this.$refs.createRef.validate(async (valid) => {
        if (valid) {
          await friendInsert(this.createFormAlign).then((res) => {
            if (res.message == "success") {
              this.$message.success("新增成功!");
              this.createVisible = false;
              this.tableData = [];
              this.queryInfo.pageNo = 1;
              this.friendTable();
            } else {
              this.createVisible = false;
              this.tableData = [];
              this.queryInfo.pageNo = 1;
              this.friendTable();
              return this.$message.error(res.message);
            }
          });
        }
      });
    },
    //删除
    deleteUser(row) {
      if (row) {
        this.templatei = row;
      }
      if (this.templatei.id) {
        this.ID = this.templatei.id;
        this.deleteFormVisible = true;
      } else {
        this.$message.error("请先选中一行数据");
      }

      console.log(row);
    },
    // 单个删除
    deleteDialog() {
      friendDelete({ ID: this.ID }).then((res) => {
        if (res.success == true) {
          this.$message.success("删除成功!");
          this.deleteFormVisible = false;
          this.tableData = [];
          this.queryInfo.pageNo = 1;
          this.friendTable(); //列表刷新
        } else {
          return false;
        }
      });
    },
    // 多选删除

    //审核
    auditBtn(row) {
      this.auditFormLabelAlign = {};
      if (row) {
        this.templatei = row;
      }
      if (this.templatei.id) {
        this.auditVisible = true;
        this.auditFormLabelAlign = this.templatei;

        this.auditId = this.templatei.stateID;
        if (this.templatei.stateID) {
          this.cityList(this.templatei.stateID);
        }
      } else {
        this.$message.error("请先选中一行数据");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#requisition {
  // height: 1400px;
}
.header {
  .header-text {
    width: 22rem;
    height: 50px;
    // margin-top: 20px;
    color: #76734f;
  }
  .card-pagination {
    height: 50px;
  }
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角

/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .el-tabs__item {
    width: 42%;
    font-size: 12px !important;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }

  // 创建弹窗样式
  .create {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 30px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .no-card {
    height: 120px;
  }
  // 修改弹窗样式
  .revise {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 30px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  // 审核弹窗样式
  .audit {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 30px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  // 删除弹框样式
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
</style>
